import { checkFileExtension, throwError, webpIsEnable$ } from '../utils'
import getRequest from './create'
import { obj2string } from '@base/lang'
import { getToken } from './utils'
import appExpose from '@app/expose'

const { config } = appExpose

export const createAxiosConfig = (playerId?: string) => {
  const headers = {
    'ONEMT-PLAYERID': playerId == null ? '' : playerId,
    'ONEMT-TOKEN': getToken(),
  }

  return {
    headers,
  }
}

export const throwRequestError = (err: unknown, name: string) => {
  let _err
  if (err instanceof Error) {
    _err = err
  } else {
    _err = new Error(`Axios (in request/${name}) Error: ${obj2string(err)}`)
  }
  window.onemtMonitor.errorReport(_err)
  console.error(_err)
}

export async function bind(playerId: string) {
  const $request = getRequest()

  let res: PlayerType | 0 = 0
  try {
    await $request.post<{ category: PlayerType }>(
      `/event/${config.serverName}/user/bind`,
      {},
      createAxiosConfig(playerId)
    )
    // 固定赋值
    res = 2
  } catch (error) {
    throwRequestError(error, 'bind')
  }
  return res
}

export async function isbind(zoneId: Zone['zoneId']) {
  const $request = getRequest()

  let res: BindedPlayer = {
    category: 1 as PlayerType,
    isUserBind: false,
    isCodeBind: false,
    zoneId,
    playerId: '',
    serverId: '',
    nickName: '',
  }

  if (!getToken()) return res

  try {
    res = await $request.post(
      `/event/${config.serverName}/show/isbind`,
      {},
      {
        headers: {
          'ONEMT-TOKEN': getToken(),
        },
      }
    )
  } catch (error) {
    throwRequestError(error, 'isbind')
  }
  return res
}

let cachePropMap: { [id: string]: Prop } = {}
export async function getItems(
  _items: string[],
  options: {
    disableWebp?: boolean
  } = {}
) {
  const { disableWebp } = Object.assign({ disableWebp: false }, options)

  const $request = getRequest()
  const items = _items.filter((id) => !cachePropMap[id])

  if (items.length === 0) return cachePropMap

  let res: typeof cachePropMap = {}
  try {
    res = await $request.post(
      '/items/reward/query',
      {
        items,
        lang: window.lang,
      },
      createAxiosConfig()
    )
    const webpIsEnable = disableWebp ? false : await webpIsEnable$
    if (webpIsEnable) {
      Object.keys(res).forEach((id) => {
        const item = res[id]
        const [ext, getNewUrl] = checkFileExtension(item.icon)
        if (ext) {
          item.icon = getNewUrl('webp')
        }
      })
    }
  } catch (error) {
    throwRequestError(error, 'itemsQuery')
  }
  cachePropMap = Object.assign({}, cachePropMap, res)
  return cachePropMap
}

export const getRewardViewList = (
  list: RewardList,
  propMap: Awaited<ReturnType<typeof getItems>>
) =>
  list
    .map((reward) => {
      const prop = propMap[reward.id]
      if (prop == null) {
        return {
          count: reward.count,
          name: String(reward.id),
          desc: '',
          icon: '',
          isWon: reward.isWon,
        }
      }
      return {
        count: reward.count,
        name: prop.name,
        desc: prop.desc,
        icon: prop.icon,
        isWon: reward.isWon,
      }
    })
    .filter((item) => !!item.icon)
